import { render, staticRenderFns } from "./BuyForSomeoneElseCover.vue?vue&type=template&id=049ee9ac&scoped=true"
import script from "./BuyForSomeoneElseCover.vue?vue&type=script&lang=js"
export * from "./BuyForSomeoneElseCover.vue?vue&type=script&lang=js"
import style0 from "./BuyForSomeoneElseCover.vue?vue&type=style&index=0&id=049ee9ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049ee9ac",
  null
  
)

export default component.exports